import { useState, useEffect } from 'react';
import { useSuperQuery } from '@vadiun/react-hooks-legacy';
import { useDriverSettlementRepository } from '../services/driverSettlementsRepository';
import {
  SettlementsColumnVisibility,
  DriverPendingSettlementsFiltersType,
  getDefaultFilters,
  getDefaultColumnVisibility,
  loadStateFromLocalStorage,
  saveStateToLocalStorage,
} from '../utils/settlementsStorage';

// Re-exportar para mantener compatibilidad
export {
  settlementsColumnLabels,
  getDefaultFilters
} from '../utils/settlementsStorage';

export const useDriverSettlements = () => {
  const driverSettlementRepo = useDriverSettlementRepository();

  // Un solo estado que engloba todo
  const [state, setState] = useState(loadStateFromLocalStorage);

  // Sincronizar con localStorage
  useEffect(() => {
    saveStateToLocalStorage(state);
  }, [state]);

  // Usar valores primitivos para las dependencias de useSuperQuery
  const pendingSettlementQuery = useSuperQuery(
    () => driverSettlementRepo.getPendingSettlement(state.filters),
    { showSpinner: true },
    ['pending_settlement', state.filters]
  );

  const onFiltersChange = (filtersEntry: DriverPendingSettlementsFiltersType) => {
    setState((prev) => ({ ...prev, filters: filtersEntry }));
  };

  const setColumnVisibility = (
    newColumnVisibility: SettlementsColumnVisibility
  ) => {
    setState((prev) => ({ ...prev, columnVisibility: newColumnVisibility }));
  };

  const resetState = () => {
    setState({
      filters: getDefaultFilters(),
      columnVisibility: getDefaultColumnVisibility()
    });
  };

  return {
    settlements: {
      data: pendingSettlementQuery.data?.data || [],
      resumen: pendingSettlementQuery.data?.resumen,
      isLoading: pendingSettlementQuery.isLoading,
      error: pendingSettlementQuery.error
    },
    reload: pendingSettlementQuery.reload,
    filters: state.filters,
    columnVisibility: state.columnVisibility,
    setColumnVisibility,
    resetState,
    onFiltersChange
  };
};
